__turbopack_context__.v({
  "h2Lg": "cBBLda_h2Lg",
  "p": "cBBLda_p",
  "pLg": "cBBLda_pLg",
  "primaryButton": "cBBLda_primaryButton",
  "primaryLink": "cBBLda_primaryLink",
});
